import { GridContainer, NoData, Span } from "@common";
import { Loader, SearchContent, TablePagination } from "@components";
import { Button } from "antd";
import { FaPlus } from "@icons";
import { useEffect, useMemo, useState } from "react";

import { Dispatch, RootState } from "@store";
import { useDispatch, useSelector } from "react-redux";

import { COLUMNS } from "./Table/columns";
import { RoleAdd } from "./Add/RoleAdd";
import { RoleEdit } from "./Edit/RoleEdit";

export const RoleManagementPage = () => {
  const column = useMemo(() => COLUMNS, []);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch<Dispatch>();
  const tableName = "role";

  const [searchData, setSearchData] = useState({
    filter: "keyword",
    value: "",
  });

  const [openModal, setOpenModal] = useState<boolean>(false);

  const dataRole: any[] = useSelector(
    (state: RootState) => state.Table.tables[tableName].data
  );

  const userAccess = useSelector(
    (state: RootState) => state.User.userInfo?.role_name?.access_group_id
  );

  const roleId: any = useSelector(
    (state: RootState) => state.UI.forms.editRole?.id
  );

  const getRoleData = async () => {
    try {
      setIsLoading(true);

      dispatch.Table.updatePageIndex({
        table: tableName,
        value: 1,
      });
      dispatch.Table.updatePageLimit({ table: tableName, value: 10 });
      dispatch.Table.getRoleList({
        table: tableName,
      });
    } catch (error) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    dispatch.UI.updateFormId({
      target: "editRole",
      value: null,
    });
    dispatch.UI.updateState({ promoCode: "", promoModal: false });
    dispatch.Table.updateKeyword({ table: tableName, value: "" });
    getRoleData();
  }, []);

  const setFilters = () => {
    setIsLoading(true);
    const keyvalue =
      searchData?.value === ""
        ? ""
        : `&${searchData?.filter}=${searchData?.value}`;
    dispatch.Table.updateKeyword({ table: tableName, value: keyvalue });
    dispatch.Table.updatePageIndex({
      table: tableName,
      value: 1,
    });
    setIsLoading(false);
    getRoleData();
  };

  useEffect(() => {
    dispatch.Table.updatePageIndex({
      table: tableName,
      value: 1,
    });
    setSearchData({ filter: "keyword", value: "" });
  }, []);

  const searchOptions = [
    {
      value: "keyword",
      label: "Keyword",
    },
    {
      value: "role_name",
      label: "Role Name",
    },
    {
      value: "role_status",
      label: "Status",
    },
    {
      value: "createdBy",
      label: "Created By",
    },
  ];

  return (
    <>
      <Loader isLoading={isLoading} />
      <div className="main">
        <GridContainer grid="two">
          <Span weight="bold" size="2xl">
            Role Management
          </Span>

          <div className="search-bar">
            <SearchContent
              searchOptions={searchOptions}
              setFilters={setFilters}
              setSearchData={setSearchData}
              searchData={searchData}
            />

            {userAccess?.role_add && (
              <Button
                onClick={() => {
                  setOpenModal(true);
                }}
                type="primary"
                size="large"
              >
                <div className="flex pr-2 items-center">
                  <FaPlus className="my-auto mx-2 text-md items-center inline-flex" />
                  Add
                </div>
              </Button>
            )}
          </div>
        </GridContainer>

        {dataRole?.length > 0 ? (
          <TablePagination
            columns={column}
            data={dataRole}
            dataType={tableName}
          />
        ) : (
          <NoData />
        )}

        {/* Add */}
        <RoleAdd
          openModal={openModal}
          setOpenModal={setOpenModal}
          getData={getRoleData}
        />

        {/* Edit */}
        {roleId && <RoleEdit getData={getRoleData} id={roleId} />}
      </div>
    </>
  );
};
